/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation CBRRouteDelete($routeId: ID!) {
    CBRRouteDelete(routeId: $routeId) {
        message
        status
    }
} 
`

